import { HomePage } from '@/pages/HomePage';

export function App() {
  return <HomePage />;
}
